export enum AllCookies {
  /**
   * From `https://www.shopify.com/legal/cookies`:
   * Used to identify a given browser session/shop combination. Duration is 30 minute rolling expiry of last use.
   */
  ShopifySessionId = "_shopify_s",
}

export function getCookie(cookieName: string): string | undefined {
  const maybeCookie = document.cookie
    .split("; ")
    .find((cookie) => cookie.startsWith(cookieName + "="));
  return maybeCookie
    ? // @ts-expect-error TODO: noUncheckedIndexedAccess FIXME
      decodeURIComponent(maybeCookie.split("=")[1])
    : undefined;
}
